import * as React from 'react';
import { Box, Grid, Paper, Typography } from '@mui/material';

import { ReactComponent as ArtSvg } from 'assets/images/art.svg';
import { ReactComponent as BulletSvg } from 'assets/images/bullet.svg';
import { theme } from 'configs';
import { AuthSignupForm } from 'forms';

interface HomePageProps {}

export const HomePage: React.FC<HomePageProps> = () => {
  return (
    <Grid container>
      <Grid item xs={12} md={6} bgcolor="#f8f8f8">
        <Box paddingTop={{ xs: 6, md: 15 }} paddingBottom={6} paddingX={{ xs: 2, lg: 2 }}>
          <Grid container spacing={4}>
            <Grid item xs={12} sm={3} display="flex" justifyContent={{ xs: 'flex-start', sm: 'flex-end' }}>
              <ArtSvg />
            </Grid>
            <Grid item xs={12} sm={9} lg={6}>
              <Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: {
                      xs: '2rem',
                      md: '3rem',
                    },
                    fontWeight: '600',
                    lineHeight: 1,
                  }}
                >
                  A New Commitment to Building Intelligence
                </Typography>

                <Box paddingY={6}>
                  <Typography
                    sx={{
                      fontSize: '1.125rem',
                      lineHeight: 1.25,
                    }}
                  >
                    Powerful features that reinforce cleaning industry best practices
                  </Typography>
                </Box>

                <Grid container spacing={1}>
                  {['Consumer Based Technology', 'Accountable Action', 'Transparent Updates'].map((val) => (
                    <Grid key={`${val}`} item xs={12} display="flex" alignItems="center">
                      <BulletSvg />
                      <Box marginLeft={1.5}>
                        <Typography
                          sx={{
                            fontWeight: '600',
                          }}
                        >
                          {val}
                        </Typography>
                      </Box>
                    </Grid>
                  ))}
                </Grid>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Grid>

      <Grid
        item
        xs={12}
        md={6}
        bgcolor={theme.palette.primary.light}
        paddingX={{ xs: 2, sm: 6, lg: 12 }}
        paddingTop={{ xs: 4, md: 3 }}
        paddingBottom={{ xs: 4, md: 8 }}
        minHeight={{ md: 'calc(100vh - 64px)' }}
      >
        <Paper
          elevation={16}
          sx={{
            borderRadius: 2,
            maxWidth: theme.breakpoints.values.sm,
            marginX: 'auto',
          }}
        >
          <Box paddingX={{ xs: 2, sm: 3, lg: 6 }} paddingTop={6} paddingBottom={4}>
            <Typography
              variant="h5"
              align="center"
              gutterBottom
              sx={{
                fontWeight: '600',
              }}
            >
              Let’s Create Your Account
            </Typography>
          </Box>

          <Box paddingX={{ xs: 2, sm: 3, lg: 6 }} paddingBottom={6}>
            <AuthSignupForm submitButtonText="Let’s Go!" />
          </Box>
        </Paper>
      </Grid>
    </Grid>
  );
};
